import { atom } from "recoil";

export const materialsState = atom({
  key: "materialsState",
  default: {},
});
